import { TierName } from '@order/graphql';
import { useSweetpassTier } from '@order/hooks';

export const useSweetPassOptions = () => {
  const { sweetpassTierName } = useSweetpassTier('cache-and-network');

  const isSweetpassJoinItemVisible =
    Boolean(sweetpassTierName) && sweetpassTierName === TierName.OptedOut;

  const isSweetpassMembershipItemVisible =
    Boolean(sweetpassTierName) && sweetpassTierName !== TierName.OptedOut;

  return { isSweetpassJoinItemVisible, isSweetpassMembershipItemVisible };
};
